import css from 'styled-jsx/css';

export default css`@charset "UTF-8";
.commentPop__content {
  padding: 0 10px;
  padding-top: 5px;
  border-bottom: 1px solid #e3e3e3; }
  .commentPop__content.commentPop__content--comment {
    background-color: #fff;
    border: none; }
  .commentPop__content textarea {
    width: calc(100% - 20px);
    border: 0;
    outline: none;
    font-size: 1em;
    background: #f7f7f7;
    padding: 10px;
    resize: none; }
  .commentPop__content .commentPop__clapArea {
    display: flex;
    align-items: center; }
    .commentPop__content .commentPop__clapArea > span {
      flex: 1; }
    .commentPop__content .commentPop__clapArea .clapArea__count {
      position: absolute;
      top: 5%;
      left: 60%;
      background-color: #7d7af4;
      color: white;
      line-height: 30px;
      border-radius: 50%;
      width: 30px;
      opacity: 0; }
      .commentPop__content .commentPop__clapArea .clapArea__count.clapArea__count--highlight {
        opacity: 1; }
      .commentPop__content .commentPop__clapArea .clapArea__count.clapArea__count--jump {
        animation: jumpping 0.8s; }
    .commentPop__content .commentPop__clapArea .clapArea__text::before {
      display: inline-block; }
    .commentPop__content .commentPop__clapArea .clapArea__text:not([score='0'])::before {
      color: #7d7af4; }
    .commentPop__content .commentPop__clapArea .clapArea__clap {
      position: relative;
      width: 100px;
      height: 100px;
      margin: 20px 0;
      border-radius: 50%; }
    .commentPop__content .commentPop__clapArea .clapArea__clap::before {
      content: '';
      display: inline-block;
      position: absolute;
      border-radius: 50%;
      background-color: #fff;
      width: calc(100% - 6px);
      height: calc(100% - 6px);
      background-image: linear-gradient(#fff 50%, #fff 50%);
      top: 3px;
      left: 3px; }
    .commentPop__content .commentPop__clapArea .clapArea__clap::after {
      content: '';
      display: inline-block;
      position: absolute;
      border-radius: 50%;
      background: url("https://static.popdaily.com.tw/img/globalicon/lightgrey/clap.png") center no-repeat;
      width: calc(100% - 10px);
      height: calc(100% - 10px);
      top: 5px;
      left: 5px;
      box-shadow: 0 2px 25px 0 #eee;
      background-size: 60%; }
    .commentPop__content .commentPop__clapArea .clapArea__clap--highlight::after {
      background: url("https://static.popdaily.com.tw/img/globalicon/clap-gradient.png") center no-repeat;
      background-size: 60%;
      box-shadow: 0 2px 25px 0 #7d7af4; }
    .commentPop__content .commentPop__clapArea .clapArea__hooray {
      display: none;
      position: absolute;
      width: calc(100% + 20px);
      height: calc(100% + 20px);
      background: url("https://static.popdaily.com.tw/img/globalicon/bubble.png") center no-repeat;
      background-size: contain;
      top: -10px;
      left: -10px;
      transition: opacity 200ms;
      opacity: 0;
      animation: rotation 2s infinite linear; }

button {
  color: #fff;
  border: none;
  outline: 0;
  background: #7d7af4;
  border-radius: 4px;
  font-size: 1em; }
  button.full-width {
    display: block;
    width: calc(100% - 24px);
    margin: 12px auto 45px;
    height: 2.2em;
    padding: 0.4em 0;
    margin-bottom: 110px; }

.commentPop__wrapper .btn.cancel {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-bottom: calc(20px + constant(safe-area-inset-bottom));
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  letter-spacing: 2px;
  font-size: 1rem;
  font-weight: normal;
  text-align: center;
  background-color: #fff;
  cursor: pointer; }

.commentPop__wrapper .btn.cancel::after {
  content: '關閉'; }

.commentPop__wrapper.commentPop__wrapper--comment {
  background-color: #fff;
  padding-bottom: calc(20px + env(safe-area-inset-bottom)); }
  .commentPop__wrapper.commentPop__wrapper--comment button {
    margin-bottom: 0; }

@keyframes jumpping {
  0% {
    transform: translate(0, 0); }
  50% {
    transform: translate(0, -10px); }
  100% {
    transform: translate(0, 0); } }

@keyframes rotation {
  from {
    -webkit-transform: rotate(0deg); }
  to {
    -webkit-transform: rotate(359deg); } }
`